"use strict";

exports.__esModule = true;
exports["default"] = CirclePlay;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CirclePlay(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M256 1C115.1 1 1 115.1 1 256s114.1 255 255 255 255-114.1 255-255S396.9 1 256 1zm120.7 275.7l-171.9 102c-19.3 11.4-35 2.1-35-20.7V154.1c0-22.8 15.7-32.1 35-20.7l171.9 101.9c19.2 11.4 19.2 30 0 41.4z"
  }));
}